// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type BackendListQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
}>;

export type BackendListQuery = {
  __typename?: "GraphqlQuery";
  getServerDetails: {
    __typename?: "Server";
    id: string;
    humanId: string;
    name: string;
    lastActivitySnapshotAt?: number | null;
  };
  getDatabaseDetails: {
    __typename?: "Database";
    id: string;
    datname?: string | null;
  };
};

export const BackendListDocument = gql`
  query BackendList($databaseId: ID!) {
    getServerDetails(databaseId: $databaseId) {
      id
      humanId
      name
      lastActivitySnapshotAt
    }
    getDatabaseDetails(databaseId: $databaseId) {
      id
      datname
    }
  }
`;

/**
 * __useBackendListQuery__
 *
 * To run a query within a React component, call `useBackendListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackendListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackendListQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useBackendListQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackendListQuery,
    BackendListQueryVariables
  > &
    (
      | { variables: BackendListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BackendListQuery, BackendListQueryVariables>(
    BackendListDocument,
    options,
  );
}
export function useBackendListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackendListQuery,
    BackendListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BackendListQuery, BackendListQueryVariables>(
    BackendListDocument,
    options,
  );
}
// @ts-ignore
export function useBackendListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BackendListQuery,
    BackendListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<BackendListQuery, BackendListQueryVariables>;
export function useBackendListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackendListQuery,
        BackendListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  BackendListQuery | undefined,
  BackendListQueryVariables
>;
export function useBackendListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackendListQuery,
        BackendListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<BackendListQuery, BackendListQueryVariables>(
    BackendListDocument,
    options,
  );
}
export type BackendListQueryHookResult = ReturnType<typeof useBackendListQuery>;
export type BackendListLazyQueryHookResult = ReturnType<
  typeof useBackendListLazyQuery
>;
export type BackendListSuspenseQueryHookResult = ReturnType<
  typeof useBackendListSuspenseQuery
>;
export type BackendListQueryResult = Apollo.QueryResult<
  BackendListQuery,
  BackendListQueryVariables
>;
